import React from 'react';
import {
  Pane,
  Heading,
  Button,
  Text,
  Paragraph,
  Icon,
  UnorderedList,
  ListItem
} from 'evergreen-ui';
import {
  formatCents,
  trialDurationMessage,
  PlanIntervalLabels
} from 'lib/subscription';

const OrganizationPlan = ({
  title,
  description,
  icon,
  perUnit,
  plan,
  alternatePlan,
  onPlanSelect,
  isSmall
}: any) => (
  <Pane
    width={isSmall ? 'auto' : 300}
    border
    hoverElevation={1}
    onClick={onPlanSelect}
    cursor="pointer"
    marginBottom={isSmall ? 16 : 0}
  >
    <Pane flex="1" padding={12} paddingTop={24}>
      <Pane
        borderRadius={100}
        width={32}
        height={32}
        padding={4}
        border
        background="tint2"
        margin="auto"
      >
        <Icon icon={icon} color="muted" size={18} />
      </Pane>

      <Heading size={600} marginTop={16} marginBottom={4}>
        {title}
      </Heading>
      <Paragraph marginBottom={16} color="muted">
        {description}
      </Paragraph>

      <Text display="block" size={400} marginBottom={4}>
        {plan.trialPeriodDays && (
          <Text color="info" display="block">
            {trialDurationMessage(plan)}.
          </Text>
        )}
        ${formatCents(plan.amountInCents)}
        {/*@ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
        {perUnit}/{PlanIntervalLabels[plan.interval]}
      </Text>

      {plan.interval === 'YEAR' && (
        <Text size={400} color="muted" display="block">
          <s>
            ${formatCents(alternatePlan.amountInCents * 12)}
            {/*@ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
            {perUnit}/{PlanIntervalLabels[plan.interval]}
          </s>
        </Text>
      )}

      <Button
        appearance="primary"
        onClick={onPlanSelect}
        justifyContent="center"
        width="100%"
        marginTop={8}
      >
        {plan.trialPeriodDays ? 'Try now for free' : 'Select plan'}
      </Button>
    </Pane>

    <Pane borderTop width="100%" textAlign="left" padding={12}>
      <Heading size={100} textAlign="center" marginTop={4}>
        Everything in individual plus
      </Heading>

      <UnorderedList icon="tick" iconColor="success">
        <ListItem>Control who can access Muru</ListItem>
        <ListItem>Customized to each provider</ListItem>
        <ListItem>Centrally manage your equipment and medications</ListItem>
        <ListItem>Add and remove users at any time</ListItem>
      </UnorderedList>
    </Pane>
  </Pane>
);

export default OrganizationPlan;
